import styled from "styled-components";

import {
    Col,
    Row as BSROW,
    Container
} from "react-bootstrap";

import 'bootstrap/dist/css/bootstrap.min.css';

enum Color {
    darkGrey = "rgb(22, 25, 29)",
    lightGrey = "rgb(44, 50, 58)",
    extraLightGrey = "rgb(88, 100, 116)",
    web360LightGrey = "rgba(50, 54, 68, 1)",
    web360DarkGrey = "rgba(50, 54, 68, 0)",

    green = "rgb(25, 139, 116)",
    lightGreen = "rgb(49, 165, 141)",

    blue = "rgb(92, 125, 204)",
    lightBlue = "rgb(119, 146, 212)",

    red = "rgb(255, 80, 80)",
    lightRed = "rgb(255, 102, 102)",

    purple = "rgb(153, 102, 255)",
    lightPurple  = "rgb(170, 128, 255)",

    yellow = "rgb(252, 173, 3)",

    white = "rgb(255, 255, 255)",
    darkWhite = "rgb(190, 190, 190)",
    black = "rgb(0, 0, 0)",

    extraDarkGrey = "rgb(16, 18, 20)",

    hoverGrey = "rgba(137, 137, 137)",
    selectedGrey = "rgba(173, 173, 173)",

    green2 = 'rgb(23, 177, 105)',
    lightGreen2 = 'rgb(43, 197, 125)',

    blue2 = 'rgb(0, 127, 255)',
    lightBlue2 = 'rgb(10, 137, 265)',

    red2 = 'rgb(198, 12, 48)',
    lightRed2 = 'rgb(220, 28, 56)',
    darkRed = "rgb(214, 64, 64)",


    yellow2 = "rgb(255, 229, 102)",
    darkerYellow = "rgb(252, 173, 3)",

    orange = "rgb(245, 141, 66)",
    lightOrange = "rgb(245, 159, 98)",

    turqoise = "rgb(99, 230, 192)",

    greenlight = "rgb(0, 255, 0)",
    redLight = "rgb(255, 60, 60)",
    yellowLight = "rgb(255, 255, 0)",
}

export default Color;

export const alpha = (color: string, alpha: number): string => {
    const c: string = color.substring(
        color.lastIndexOf("(") + 1,
        color.lastIndexOf(")")
    );
    return `rgba(${c}, ${alpha})`
}

export const List = styled.div<{ css?: string }>`
${(props) => props.css ?? ""};
`;

export const Row = styled(BSROW)<{ css?: string }>`
	${(props) => props.css ?? ""};
`;

export const Column = styled(Col)<{ css?: string }>`
	${(props) => props.css ?? ""};
`;

export const ListItem = styled(Container)<{ css?: string }>`
	${(props) => props.css ?? ""};
`;

export const SubListItem = styled.div<{ css?: string }>`
	${(props) => props.css ?? ""};
`;

export const Text = styled.p<{ css?: string }>`
	${(props) => props.css ?? ""};

`;

export const ListTitle = styled.p<{ css?: string }>`
	font-weight: 800;
	font-size: 35px;
	padding: 10px 0;
	margin-bottom: 10px;
	background-color: rgba(39, 42, 55, 1);
	border-radius: 15px 15px 0 0;
	text-align: center;
	${(props) => props.css ?? ""};
`;

export const Img = styled.img<{ css?: string }>`
	${(props) => props.css ?? ""};
`;

export const Accor = styled.div<{ css?: string }>`
	${(props) => props.css ?? ""};
	background-color: #fff5;
`;

export const OpenedScan = styled.div<{ css?: string }>`
	${(props) => props.css ?? ""};
`;

export const StyledDiv = styled.div<{ css?: string }>`
	${(props) => props.css ?? ""};
`;

export const StyledMapButton = styled.button<{ css?: string }>`
	${(props) => props.css ?? ""};
`;

export const NavTitleText = styled.p<{ css?: string }>`
	${(props) => props.css ?? ""};
	margin: auto;
	text-align: center;
	width: 42.78px;
	height: 15.56px;
	font-weight: 800;
	line-height: 16px;
	color: #9AA5B5;
`;

export const NavValueText = styled.p<{ css?: string }>`
	${(props) => props.css ?? ""};
	margin: auto;
	text-align: center;
	font-weight: 800;
	font-size: auto;
	color: #FFFFFF;
`;

export const MapText = styled.div<{ css?: string }>`
	${(props) => props.css ?? ""};
`;

export const Flex = styled("div")<{direction: string, css?: string}>`
    display: flex;
    flex-direction:  ${props => props.direction};
    height: 100%;
    width: 100%;
    ${props => props.css ?? ""}
`

export const HorizontalFlex = styled("div")<{css?: string}>`
    display: flex;
    width: auto;
    height: auto;
    border-radius: 20px;

    ${props => props.css ?? ""}
`

export const VerticalFlex = styled("div")<{css?: string}>`
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    ${props => props.css ?? ""}
`

export const SaveButton = styled("div")<{css?: string}>`
    position: absolute;
    width: fit-content;
    height: 25px;
    border-radius: 5px;

    top: 20px;
    right: 20px;

    padding: 5px;
    padding-left: 15px;
    padding-right: 15px;

    background-color: ${Color.green};

    font-size: 12px;
    font-weight: bold;
    color: white;
    line-height: 25px;

    user-select: none;
    cursor: pointer;
    z-index: 5;
    transition: 0.3s ease;

    ${props => props.css ?? ""}

    &: hover {
        background-color: ${Color.lightGreen};
    }

    ${props => props.css ?? ""}
`

export const PageTitle = styled("h1")<{fontSize?: number}>`
    font-size: ${props => props.fontSize ?? 35}px;
    color: white;
    text-align: left;
    margin: 0;
`

export const PageIcon = styled("div")<{icon: string, size?: number}>`
    width: ${props => props.size ?? 35}px;
    height: ${props => props.size ?? 35}px;
    margin-right: 20px;

    border-width: 0;
    outline: none;

    cursor: pointer;

    background-size: contain;
    mask: url(${props => props.icon}) no-repeat 50% 50%;
    mask-size: cover;

    background-color: white;
`

export const Input = styled("input")<{focusBorder: boolean, borderColor?: string, fontSize?: number, css?: string}>`
    position: relative;
    margin: 0;
    margin-top: 5px;
    height: 45px;
    width: 100%;
    outline: none;
    border: 0px solid ${Color.green};
    padding: 10px;
    border-radius: 5px;
    ${props => props.focusBorder ? "border-left: 3px solid transparent;" : ""}

    background: ${Color.darkGrey};

    text-align: left;
    color: white;
    font-size: ${props => props.fontSize ?? 11}px;
    font-family: Montserrat, sans-serif;
    font-weight: normal;

    box-sizing: border-box;

    transition: 0.3s ease;

    ${props => props.focusBorder ? `
        &: focus {
            border-left: 3px solid ${props.borderColor ?? Color.green};
        }
    ` : ""}

    ::placeholder {
        color: white;
        opacity: 50%;
        font-size: ${props => props.fontSize ?? 11}px;
    }

    ${props => props.css ?? ""};
`


export const Button = styled("div")<{color: string, hoverColor: string, css?: string}>`
    border-radius: 5px;

    color: white;
    font-size: 13px;
    font-weight: bold;

    user-select: none;
    cursor: pointer;

    background-color: ${props => props.color};

    background-position: center;
    transition: background 0.8s;

    &: hover {
        background: ${props => props.color} radial-gradient(circle, transparent 1%, ${props => props.color} 1%) center/15000%;
    }
    &: active {
        background-color: ${props => props.hoverColor};
        background-size: 100%;
        transition: background 0s;
    }

    ${props => props.css ?? ""}
`

export const MessageDiv = styled.div`
    position: relative;
    width: auto;
    height: fit-content;
    padding: 10px;
    margin-bottom: 20px;

    font-size: 12px;
    font-weight: bold;

`

export const ErrorDiv = styled(MessageDiv)`
    background: rgba(255, 80, 80, 0.2);
    color: ${Color.red};
    border: 1px solid ${Color.red};
    border-radius: 5px;
`

export const SuccessDiv = styled(MessageDiv)`
    background: rgba(25, 139, 116, 0.2);
    color: ${Color.lightGreen};
    border: 1px solid ${Color.green};
    border-radius: 5px;
`

export const LinkButton = styled.div`
    background: transparent;
    margin-right: 10px;

    text-align: center;
    color: ${Color.extraLightGrey};
    font-size: 12px;
    font-weight: normal;
    text-decoration: none;

    user-select: none;
    cursor: pointer;
    transition: 0.3s ease;

    &: hover {
        color: white;
    }
`

export const Logo = styled.img`
    max-width: 60%;
    height: auto;
    margin: 0;
    margin-top: 20px;
`


export const ViewContainer = styled.div`
    position: relative;
    min-height: 100%;
    height: auto;
    overflow: auto;
    margin: 15px;

    animation-fill-mode: forwards;
`

export const StyledButton = styled(Button)`
    height: 50px;
    width: 280px;
    margin-top: 8em;
    padding: 12px;
    text-align: center;
    font-size: 18px;
    font-weight: 600;
    border-radius: 15px;
    background-color:rgb(25, 139, 116);
    color: white;
    border: none;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
        transform: translateY(-2px);
    }

    &:active {
        transform: translateY(0);
    }
`
export const StyledInput = styled.input`
    margin-top: 20px;
    padding: 14px;
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    background-color: rgba(31, 41, 55, 0.8);
    color: #fff;
    font-size: 16px;
    width: 100%;
    box-sizing: border-box;
    transition: border-color 0.3s ease, background-color 0.3s ease;

    &:focus {
        outline: none;
        border-color: #198B74;
    }

    &::placeholder {
        color: rgba(255, 255, 255, 0.5);
    }
`;

export const StyledSelect = styled.select`
    padding: 14px;
    border-radius: 12px;
    background-color: rgba(31, 41, 55, 0.8);
    color: white;
    width: 100%;
    margin-bottom: 10px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    font-size: 16px;
    transition: border-color 0.3s ease, background-color 0.3s ease;

    &:focus {
        border-color: rgb(20, 109, 93);
        background-color: rgba(31, 41, 55, 0.9);
    }
`;

export const CheckboxInput = styled.input`
    appearance: none;
    width: 18px;
    height: 18px;
    background-color: rgba(31, 41, 55, 0.8);
    border: 2px solid rgba(255, 255, 255, 0.2);
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s ease, border-color 0.3s ease;

    &:checked {
        background-color: #198B74;
        border-color: #198B74;
    }

    &:focus {
        outline: none;
        box-shadow: 0 0 0 2px rgba(31, 41, 55, 0.5);
    }
`;

export const CheckboxLabel = styled.label`
    font-size: 16px;
    cursor: pointer;
    user-select: none;
`;

export const AdminsContainer = styled.div`
    margin-top: 10px;
    padding-left: 70px;
`;

export const AdminText = styled.p`
    color: white;
    font-size: 14px;
    margin-bottom: 5px;
`;

export const AdminList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 5px;
`;

export const AdminItem = styled.p`
    color: white;
    font-size: 14px;
`;
